import Vue from "vue";
import VueRouter from "vue-router";
import Navigation from "../components/Navigation.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Discover",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "discover" */ "../views/Discover.vue"
                ),
            navigation: Navigation
        },
        meta: {
            title: 'Home Workout | PUMATRAC'
        }
    },
    {
        path: "/workouts/:filter?",
        name: "Workouts",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "all-workouts" */ "../views/AllWorkouts.vue"
                ),
            navigation: Navigation
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
        meta: {
            title: 'Find Workouts | PUMATRAC'
        }
    },
    {
        path: "/trainers",
        name: "Trainers",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "all-trainers" */ "../views/AllTrainers.vue"
                ),
            navigation: Navigation
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
        meta: {
            title: 'Trainers | PUMATRAC'
        }
    },
    {
        path: '/workout/:id/:christmasOverview?/:kind?',
        name: 'WorkoutOverview',
        components: {
            default: () =>
            import(
                /* webpackChunkName: "workout-overview" */ "../views/WorkoutOverview.vue"
            ),
          navigation: Navigation
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
        meta: {
            title: 'Workout | PUMATRAC'
        }
    },
    {
        path: '/workout/:id/train',
        name: 'WorkoutProgress',
        components: {
            default: () =>
            import(
                /* webpackChunkName: "workout-progress" */ "../views/WorkoutProgress.vue"
            ),
            navigation: false
        },
        meta: {
            title: 'Workout | PUMATRAC'
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import(/* webpackChunkName: "forgot-password" */ "../views/ForgotPassword.vue"),
        meta: {
            title: 'Forgot Password | PUMATRAC'
        }
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import(/* webpackChunkName: "forgot-password" */ "../views/ResetPassword.vue"),
        meta: {
            title: 'Reset Password | PUMATRAC'
        }
    },
    {
        path: '/login',
        name: 'Login',
        components: {
            default: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
            navigation: Navigation
        },
        props: {
            default: {
                mode: 'login',
            },
            navigation: {
                hideLogin: true,
            }
        },
        meta: {
            title: 'Login | PUMATRAC'
        }
    },
    {
        path: '/register',
        name: 'Register',
        components: {
            default: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
            navigation: Navigation
        },
        props: {
            default: {
                mode: 'register',
            },
            navigation: {
                hideLogin: true,
            }
        },
        meta: {
            title: 'Register | PUMATRAC'
        }
    },
    {
        path: '/register/:step',
        name: 'RegistrationSteps',
        component: () => import(/* webpackChunkName: "registration-steps" */ "../views/RegistrationSteps.vue"),
        meta: {
            title: 'Register | PUMATRAC'
        },
    },
    {
        path: '/profile',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "profile" */ "../views/Profile.vue"
                ),
            navigation: Navigation,
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
        meta: {
            title: 'Your Profile | PUMATRAC'
        },
        children: [
            {   
                name: 'Profile',
                path: '', 
                component: () => import(/* webpackChunkName: "user-activities" */ "../components/UserActivities.vue")
            },
            {
                name: 'Account',
                path: 'account',
                component: () => import(/* webpackChunkName: "user-account" */ "../components/UserAccount.vue")
            },
            {
                name: 'FitnessSettings',
                path: 'fitness-settings',
                component: () => import(/* webpackChunkName: "user-fitness-settings" */ "../components/UserFitnessSettings.vue")
            },
            {
                name: 'DeleteAccount',
                path: 'delete-account',
                component: () => import(/* webpackChunkName: "user-delete-account" */ "../components/UserDeleteAccount.vue")
            },
        ]
      },
      {
          path: '/trainer/:id',
          name: 'Trainer',
          components: {
            default: () =>
                import(
                    /* webpackChunkName: "trainer" */ "../views/Trainer.vue"
                ),
            navigation: Navigation
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
          meta: {
            title: 'Trainer | PUMATRAC'
        },
      },
      {
        path: '/opportunity/:id/:christmasOverview?',
        name: 'Opportunity',
        components: {
            default: () =>
            import(
                /* webpackChunkName: "workout-overview" */ "../views/WorkoutOverview.vue"
            ),
          navigation: Navigation
        },
        props: {
            default: true,
            navigation: {showBack: true}
        },
        meta: {
            title: 'Opportunity | PUMATRAC'
        }
    },
    {
        path: "/christmas-calendar",
        name: "Christmas Calendar",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "discover" */ "../views/ChristmasCalendar.vue"
                ),
            navigation: Navigation
        },
        props: {
            default: true,
            navigation: {
                showBack: true,
                christmasCalendar: true,
            }
        },
        meta: {
            title: 'Christmas Calendar | PUMATRAC'
        }
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

export default router;
